import React from 'react';
import PropTypes from 'prop-types';

import {Box, CircularProgress} from 'views/components';
import {InsertDriveFile} from 'views/icons';

const FileDisplay = (props) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const getDownloadedSrc = props.getDownloadedSrc;
  const sx = props.sx;

  const openFile = () => {
    const downloadFile = async () => {
      const src = await getDownloadedSrc();
      window.open(src);
      setIsLoading(false);
    };

    setIsLoading(true);
    downloadFile();
  };

  return (
    <Box
      position='relative'
      onClick={openFile}
      height='100%'
      width='100%'
      sx={{
        cursor: isLoading ? 'wait' : 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        ...sx,
      }}
    >
      <InsertDriveFile
        sx={{
          width: 'max-content',
          height: 'max-content',
        }}
      />
      {
        isLoading &&
        <Box
          position="absolute"
          top={0}
          left={0}
          width='100%'
          height='100%'
          sx={{
            zIndex: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0, 0.25)',
          }}
        >
          <CircularProgress />
        </Box>
      }
    </Box>
  );
};

FileDisplay.propTypes = {
  getDownloadedSrc: PropTypes.func.isRequired,
  sx: PropTypes.object,
};

export default FileDisplay;
